import ShyBearFilms from './shybear_films';
export default function App() { return <ShyBearFilms />; }